<template>
  <div class="ap-page pay-result">
    <div class="pay-result-card">
      <span class="pay-result-ring pay-result-ring--fail"><v-icon size="46" color="white">mdi-close-thick</v-icon></span>
      <span class="ap-kicker">e-Treasury payment</span>
      <h1 class="pay-result-title">Payment <em>not completed.</em></h1>
      <p class="pay-result-text">The payment did not go through and no amount was taken. You can try again from your application.</p>
      <router-link to="/mybooking" class="ap-btn ap-btn--primary">
        Back to my applications
        <v-icon small>mdi-arrow-right</v-icon>
      </router-link>
      <p class="pay-result-redirect">Taking you there in {{ seconds }}s…</p>
    </div>
  </div>
</template>

<script>
// e-Treasury returns here after a failed payment
// (backend /challan/generation/response redirects to /FailurePage).
export default {
  name: "FailurePage",
  data() {
    return { seconds: 5 };
  },
  mounted() {
    this.timer = setInterval(() => {
      this.seconds -= 1;
      if (this.seconds <= 0) {
        clearInterval(this.timer);
        this.$router.push({ path: "/mybooking" });
      }
    }, 1000);
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
};
</script>

<style scoped>
.pay-result {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: calc(100vh - 120px);
}

.pay-result-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 520px;
  padding: 44px 36px 36px;
  border-radius: 28px;
  border: 1px solid var(--ap-line);
  background: #ffffff;
  text-align: center;
  box-shadow: 0 30px 70px rgba(15, 26, 20, 0.1);
}

.pay-result-ring {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 92px;
  height: 92px;
  margin-bottom: 22px;
  border-radius: 50%;
}

.pay-result-ring--fail {
  background: linear-gradient(180deg, #ef4444, #b91c1c);
  box-shadow: 0 0 0 10px #fee2e2, 0 18px 40px rgba(220, 38, 38, 0.3);
}

.pay-result-title {
  margin: 0 0 10px;
  font-family: "Inter", sans-serif;
  font-size: 38px;
  font-weight: 500;
  color: var(--ap-ink);
}

.pay-result-title em {
  font-style: italic;
  color: #b91c1c;
}

.pay-result-text {
  margin: 0 0 26px;
  font-size: 15px;
  line-height: 1.65;
  color: var(--ap-muted);
}

.pay-result-redirect {
  margin: 14px 0 0;
  font-size: 12.5px;
  color: var(--ap-muted);
}
</style>
